module.exports = __webpack_public_path__ + "images/Farfetch-ddc460.png";